import React, { PropsWithChildren } from 'react';
import { Chip, Typography } from '@material-ui/core';
import moment from 'moment';
import { IActivePlan } from '../interfaces/IActivePlan';

interface CurrentPlanItemProps {
  plan: IActivePlan;
  showRenewal: boolean;
}
const CurrentPlanItem = (props: PropsWithChildren<CurrentPlanItemProps>) => {
  const { plan, showRenewal } = props;
  const {
    type,
    price,
    interval,
    cancelAtPeriodEnd,
    currency,
    renewalDate
  } = plan;
  let message = `Your plan renews on ${moment(renewalDate).format(
    'MMMM Do, YYYY'
  )}`;
  if (moment(renewalDate) < moment(new Date()) && cancelAtPeriodEnd) {
    message = `Your plan was cancelled on ${moment(renewalDate).format(
      'MMMM Do, YYYY'
    )}`;
  } else if (cancelAtPeriodEnd) {
    message = `Your plan will cancel on ${moment(renewalDate).format(
      'MMMM Do, YYYY'
    )}`;
  }
  return (
    <>
      <Typography
        variant={'h5'}
        style={{ display: 'flex', alignItems: 'center' }}
      >
        {type}
        {cancelAtPeriodEnd && (
          <Chip
            size={'small'}
            style={{ color: 'black', marginLeft: '10px', height: '20px' }}
            label={'Cancelled'}
          />
        )}
      </Typography>
      {/* If free trial then displaying $29 per year */}
      <Typography variant={'body1'}>
        {price === 0
          ? `${currency.toUpperCase()} $29 per ${interval}`
          : `${currency.toUpperCase()} ${price} per ${interval}`}
      </Typography>
      {showRenewal ? (
        <Typography variant={'body1'}>{message}</Typography>
      ) : null}
    </>
  );
};
export default CurrentPlanItem;
